import { Card } from 'antd'
import { AdminCModal, CButton } from 'app/components/Common'
import React, { useState } from 'react'
import { COLORS } from 'app/constants'
import EventUpdateImage from './EventUpdateImage'
import EventInput from 'app/adminpages/AdminEvents/EventInput'
import { useEvents } from 'app/hooks/Events/event'
import { awsUploadImage } from 'utils/awsImageStorage'
import { View } from 'styles/reactnative'
import { RichTextUpdateEditor } from 'app/components/'

const EventUpdateModal = ({ item, showModal, setShowModal }) => {
	const { updateEvent } = useEvents()

	const [images, setImages] = useState<any>([])
	const [apiImages, setApiImages] = useState<any>(
		JSON.parse(item?.images) || []
	)

	const [title, setTitle] = useState(item?.title)
	const [content, setContent] = useState(item?.content)

	const updateForm = async () => {
		let resultImages: any = []
		if (images?.length) {
			resultImages = await Promise.all(
				images.map(async (file, index) => {
					const resultImage = await awsUploadImage(
						{ file: file?.originFileObj },
						index + 1,
						'profile',
						'user'
					)
					return resultImage
				})
			)
		}
		await updateEvent({
			id: item.id,
			title: title,
			content: content,
			images: [
				...resultImages.filter(Boolean),
				...apiImages.filter(Boolean),
			],
		})

		setShowModal(!showModal)
	}
	return (
		<AdminCModal width={1000} show={showModal} setShow={setShowModal}>
			<Card
				title="이벤트 생성"
				style={{ minHeight: 600, height: '100%' }}>
				<EventInput
					value={title}
					setValue={setTitle}
					name={'제목'}
					placeholder={'제목'}
				/>

				<RichTextUpdateEditor
					content={content}
					setContent={setContent}
				/>
				<EventUpdateImage
					apiImages={apiImages}
					setApiImages={setApiImages}
					images={images}
					setImages={setImages}
				/>

				<View>
					<CButton
						title={'수정'}
						onClick={updateForm}
						style={{
							background: COLORS.primary,
							width: 200,
							height: 30,
							color: COLORS.white,
							alignSelf: 'center',
							position: 'absolute',
							bottom: 20,
						}}
					/>
				</View>
			</Card>
		</AdminCModal>
	)
}

export default EventUpdateModal
